import { UPDATE_DISPLAYED_CELLS } from 'actions/cells';

export default (state = [], action) => {
	switch (action.type) {
		case UPDATE_DISPLAYED_CELLS:
			return action.payload;
		default:
			return state;
	}
};